module.exports = __webpack_public_path__ + "img/logo.542cdf2a.jpg";